import { SortOrder } from 'further-types/utils';

const sortSelectOptions = [
  {
    label: 'Name (A-Z)',
    value: 'nameAZ',
  },
  {
    label: 'Name (Z-A)',
    value: 'nameZA',
  },
];

const sortByOptionToOrderMap = {
  nameAZ: {
    orderBy: 'name',
    order: SortOrder.Asc,
  },
  nameZA: {
    orderBy: 'name',
    order: SortOrder.Desc,
  },
} as const satisfies Record<
  (typeof sortSelectOptions)[number]['value'],
  { orderBy: string; order: SortOrder }
>;

type SortMapOrderBy =
  (typeof sortByOptionToOrderMap)[keyof typeof sortByOptionToOrderMap]['orderBy'];

const isValidSortKey = (
  value: string,
): value is keyof typeof sortByOptionToOrderMap =>
  Object.prototype.hasOwnProperty.call(sortByOptionToOrderMap, value);

export default function useBulkRevaluationsSort(pagination: {
  orderBy: SortMapOrderBy;
  order: SortOrder;
  handleChangeSort: (orderBy: SortMapOrderBy, order: SortOrder) => void;
}) {
  const sortSelectValue = Object.entries(sortByOptionToOrderMap).find(
    ([_, option]) =>
      option.orderBy === pagination.orderBy &&
      option.order === pagination.order,
  )?.[0];

  const handleChangeSort = (value: string) => {
    if (!isValidSortKey(value)) return;
    const { orderBy, order } = sortByOptionToOrderMap[value];
    pagination.handleChangeSort(orderBy, order);
  };

  return {
    sortSelectOptions,
    sortSelectValue: sortSelectValue ?? 'nameAZ',
    handleChangeSort,
  };
}
